import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng9RutModule } from 'ng9-rut';
import { MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import { SharedModule } from 'src/app/shared/shared.module';
import { SharedViewsModule } from '../shared/shared-views.module';
import { ChequesProtestoComponent } from './cheques-protesto/cheques-protesto.component';
import { CabeceraComponent as CabeceraProtestoComponent } from './cheques-protesto/cabecera/cabecera.component';
import { DetallesComponent as DetallesProtestoComponent } from './cheques-protesto/detalles/detalles.component';
import { ModalAddEditProtestoComponent } from './cheques-protesto/modal-add-edit-protesto/modal-add-edit-protesto.component';
import { ChequesRedepositoComponent } from './cheques-redeposito/cheques-redeposito.component';
import { CabeceraComponent as CabeceraRedepositoComponent } from './cheques-redeposito/cabecera/cabecera.component';
import { DetallesComponent as DetallesRedepositoComponent } from './cheques-redeposito/detalles/detalles.component';
import { ModalAddEditRedepositoComponent } from './cheques-redeposito/modal-add-edit-redeposito/modal-add-edit-redeposito.component';
import { ChequesCambiarFechaComponent } from './cheques-cambiar-fecha/cheques-cambiar-fecha.component';
import { ModalCambiarFechaComponent } from './cheques-cambiar-fecha/modal-cambiar-fecha/modal-cambiar-fecha.component';
import { ChequesConsultarComponent } from './cheques-consultar/cheques-consultar.component';
import { DepositoEfectivoComponent } from './deposito-efectivo/deposito-efectivo.component';
import { CabeceraComponent as CabeceraDepositoEfectivo } from './deposito-efectivo/cabecera/cabecera.component';
import { ControlResumidoComponent } from './deposito-efectivo/control-resumido/control-resumido.component';
import { DeclaracionComponent } from './deposito-efectivo/declaracion/declaracion.component';
import { TimbrarDepositoEfectivoComponent } from './timbrar-deposito-efectivo/timbrar-deposito-efectivo.component';
import { DepositoDocumentosComponent } from './deposito-documentos/deposito-documentos.component';
import { DestinoDepositoComponent } from './destino-deposito/destino-deposito.component';
import { DestinoDepositoModalAgregarBancoComponent } from './destino-deposito/modal-agregar-banco/modal-agregar-banco.component';
import { ModalDestinoDepositoComponent } from './deposito-documentos/modal-destino-deposito/modal-destino-deposito.component';
import { TimbrarDepositoComponent } from "./timbrar-deposito/timbrar-deposito.component";
import { ModalDepositoDetalleComponent } from './timbrar-deposito/modal-deposito-detalle/modal-deposito-detalle.component';
import { CajaDiariaComponent } from './caja-diaria/caja-diaria.component';
import { CajaDiariaModalDetalleComponent } from './caja-diaria/modal-detalle/modal-detalle.component';

@NgModule({
  declarations: [
    ChequesProtestoComponent,
    CabeceraProtestoComponent,
    DetallesProtestoComponent,
    ModalAddEditProtestoComponent,
    ChequesRedepositoComponent,
    CabeceraRedepositoComponent,
    DetallesRedepositoComponent,
    ModalAddEditRedepositoComponent,
    ChequesCambiarFechaComponent,
    ModalCambiarFechaComponent,
    ChequesConsultarComponent,
    DepositoEfectivoComponent,
    CabeceraDepositoEfectivo,
    ControlResumidoComponent,
    DeclaracionComponent,
    TimbrarDepositoEfectivoComponent,
    DepositoDocumentosComponent,
    DestinoDepositoComponent,
    DestinoDepositoModalAgregarBancoComponent,
    ModalDestinoDepositoComponent,
    TimbrarDepositoComponent,
    ModalDepositoDetalleComponent,
    CajaDiariaComponent,
    CajaDiariaModalDetalleComponent
  ],
  imports: [
    CommonModule,
    ToastModule.forRoot(),
    MDBBootstrapModulesPro.forRoot(),
    Ng9RutModule,
    FormsModule,
    ReactiveFormsModule,
    SharedViewsModule,
    SharedModule
  ],
  exports:[
    ChequesProtestoComponent,
    ChequesRedepositoComponent,
    ChequesCambiarFechaComponent,
    ChequesConsultarComponent,
    DepositoEfectivoComponent,
    TimbrarDepositoEfectivoComponent,
    DepositoDocumentosComponent,
    DestinoDepositoComponent,
    TimbrarDepositoComponent
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class FinanzasModule { }
